import { BrowserModule } from '@angular/platform-browser';
import { NgModule , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { CalendarModule } from 'primeng/primeng';
import { AppComponent } from './app.component';
import { HousekeepingModule } from './modules/housekeeping/housekeeping.module';
import { LeadsModule } from './modules/leads/leads.module';
import { CasesModule } from './modules/cases/cases.module';
import { OwnersModule } from './modules/owners/owners.module';
import { DashboardModule } from './modules/dashboard/dashboard.module';
import { ReportingModule} from './modules/reporting/reporting.module';
// import {LeadService} from '../app/modules/leads/services/lead.service';

import { ExpandMenu } from './modules/housekeeping/components/expand-menu.directive';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SortablejsModule } from 'angular-sortablejs';
import {AdminModule} from '../app/modules/admin/admin.module';
import * as moment from 'moment';
@NgModule({
  declarations: [
    AppComponent,
    ExpandMenu
  ],
  imports: [
    BrowserModule,
    CalendarModule,
    HousekeepingModule,
    LeadsModule,
    CasesModule,
    OwnersModule,
    BrowserAnimationsModule,
    DashboardModule,
    AdminModule,
    ReportingModule,
        // global settings
    SortablejsModule.forRoot({
      animation: 200,
    }),
  ],
  providers: [],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})


export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts